import type {
  ForefootExtensionType,
  ForefootWedgeType,
} from './prescriptionState';

/**
 * Forefoot wedge + metatarsal-extension availability rules.
 *
 * EXTRACTED, NOT AUTHORED, exactly like `heelRaiseRules.ts`. Each rule below
 * was an inline `.filter` in ForefootSection's JSX; it is lifted verbatim so
 * the section and `collectUnavailableValues` share one answer. See
 * `heelRaiseRules.ts` for why a validator cannot read an inline filter.
 *
 * NOT extracted (deliberately): the extension SOFTNESS and THICKNESS option
 * sets. Both are cascades keyed on a sibling field (`type`, then the chosen
 * rigidity), so "is this value legal" depends on a value that may itself be
 * illegal. Resolving that ordering is mapping policy, which belongs to the
 * shared legality module (housekeeping backlog item 5), not here. The checker
 * therefore does not flag those two fields yet, and that gap is stated in
 * `collectUnavailableValues`.
 */

/** All forefoot wedge type values, in display order. */
export const FOREFOOT_WEDGE_TYPE_VALUES: readonly ForefootWedgeType[] = [
  'none',
  'intrinsic',
  'extrinsic',
];

/** All metatarsal-extension type values, in display order. */
export const FOREFOOT_EXTENSION_TYPE_VALUES: readonly ForefootExtensionType[] = [
  'none',
  'intrinsic',
  'extrinsic',
];

/** R37: sandals hide the extrinsic EVA-post wedge option. */
export function forefootWedgeTypesFor(isSandal: boolean): readonly ForefootWedgeType[] {
  return isSandal
    ? FOREFOOT_WEDGE_TYPE_VALUES.filter((t) => t !== 'extrinsic')
    : FOREFOOT_WEDGE_TYPE_VALUES;
}

/** R37: sandals hide the extrinsic EVA-post extension option. */
export function forefootExtensionTypesFor(
  isSandal: boolean,
): readonly ForefootExtensionType[] {
  return isSandal
    ? FOREFOOT_EXTENSION_TYPE_VALUES.filter((t) => t !== 'extrinsic')
    : FOREFOOT_EXTENSION_TYPE_VALUES;
}
